(function (angular) {
  "use strict";

  angular.module("app").service("alerts", alertsService);

  alertsService.$inject = ["$rootScope"];
  function alertsService($rootScope) {
    $rootScope.alerts = $rootScope.alerts || [];

    /**
     * Shows an alert to the user
     * @param  {object/array} alert - Single alert object, or array of objects
     *     example: {
     *       theme?: 'error' | 'success',
     *       title: 'Message could not be sent',
     *       messages: ['Please try again'],
     *     }
     * @return {void}
     */
    function emit(alert) {
      if (alert.length) {
        angular.forEach(alert, function (item) {
          createAlert(item);
        });
      } else {
        createAlert(alert);
      }
    }

    /**
     * Creates an alert and adds to root scope.
     * @param  {object} alert -
     *   {
     *     theme?: 'error' | 'success',
     *     title: 'Connection Request Sent',
     *     messages: ['Vicky will be sent a notification']
     * }
     * @return {void}
     */
    function createAlert(alert) {
      $rootScope.$emit("alert", alert);
    }

    var service = {
      emit: emit,
    };

    // Codesmell: Attach to window so we can access from React
    window.angularServices = window.angularServices || {};
    window.angularServices.alerts = service;

    return service;
  }

  angular.module("app").directive("alerts", alertsDirective);

  alertsDirective.$inject = ["$rootScope", "$timeout"];

  function alertsDirective($rootScope, $timeout) {
    return {
      replace: true,
      templateUrl: "directives/alerts.html",
      link: function ($scope, el) {
        // properties
        $scope.alerts = [];

        // methods
        $scope.removeAlert = removeAlert;

        // Watch rootscope for new alert objects
        $rootScope.$on("alert", function (event, alert) {
          var updatedAlert = angular.merge(
            {
              cssClass: "show-alert-animation",
              theme: "default",
            },
            alert,
          );
          $scope.alerts.unshift(updatedAlert);
          setRemoveTimer(updatedAlert);
        });

        /**
         * Sets a timer to remove an alert
         * @param  {object} alert - alert object
         * @return {void}
         */
        function setRemoveTimer(alert) {
          $timeout(function () {
            removeAlert(alert);
          }, 5000);
        }

        /**
         * Removes an alert immediately
         * @param  {object} alert - alert object
         * @return {void}
         */
        function removeAlert(alert) {
          var visibleAlertIndex = $scope.alerts.indexOf(alert);

          if (visibleAlertIndex !== -1) {
            // Animate then delete
            $scope.alerts[visibleAlertIndex].cssClass = "hide-alert-animation";

            $timeout(function () {
              $scope.alerts.splice(visibleAlertIndex, 1);
            }, 200);
          }
        }
      },
    };
  }
})(angular);
